import ApiClient from './ApiClient';

class ContactSessionsAPI extends ApiClient {
  constructor() {
    super('sessions', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/sessions`;
  }

  getSessions(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  deleteSession(contactId, sessionId) {
    this.contactId = contactId;
    return super.delete(sessionId);
  }
}

export default new ContactSessionsAPI();